module.exports = __webpack_public_path__ + "sx3-3946e056.png";